module.exports = __webpack_public_path__ + "static/img/font-lg-smart@w.d386a09.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/project-detail/lgchem/font-lg-smart@w.png
// module id = yBrB
// module chunks = 0